// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BSG-compliant styles for food item modal */
/* Utility class for screen readers */
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

/* Skip link for keyboard users */
.bsg-skip-link {
  position: absolute;
  top: -9999px;
  left: -9999px;
  background: white;
  color: var(--ion-color-secondary);
  padding: 15px;
  z-index: 10000;
  font-weight: bold;
  border: 2px solid var(--ion-color-primary);
  text-decoration: none;
}
.bsg-skip-link:focus {
  top: 10px;
  left: 10px;
}

/* Container styles */
.bsg-modal-container {
  position: relative;
  height: 100%;
}

app-modal-info {
  height: 100vh;
  position: relative;
}

swiper-container {
  width: 100% !important;
  height: 100% !important;
  background-color: var(--background-color);
}

swiper-slide {
  width: 100% !important;
}

ion-page {
  background: transparent;
}

/* Slide column styles */
.slide-col {
  top: 0;
  bottom: 0;
  position: absolute;
  display: flex;
  flex-direction: column;
  background-size: 100% 30vh !important;
  overflow: auto;
}
.slide-col.add-background {
  background-size: cover;
}

/* Header wrapper styles */
.header-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 20px;
  align-items: center;
}

/* Category heading */
.category-heading {
  margin: 0;
  font-size: 18px;
  color: var(--ion-color-secondary);
}

/* Back button */
.bsg-back-button {
  background: transparent;
  border: none;
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  /* Focus styles */
  /* Hover state */
  /* Key focus styles */
}
.bsg-back-button:focus {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.bsg-back-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.bsg-back-button:focus-visible {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.bsg-back-button ion-icon {
  width: 20px;
  height: 20px;
}

/* Favorite button */
.add_fav_btn {
  width: 40px;
  height: 40px;
  background: white;
  border-radius: 50%;
  box-shadow: 0px 0px 20px 0px rgba(13, 71, 161, 0.1490196078);
  display: flex;
  align-items: center;
  justify-content: center;
  /* Focus styles */
  /* Key focus styles */
  /* Hover state */
}
.add_fav_btn.no-shadow {
  box-shadow: none;
}
.add_fav_btn:focus {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.add_fav_btn:focus-visible {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.add_fav_btn:hover {
  background-color: rgba(0, 0, 0, 0.02);
}
.add_fav_btn ion-icon {
  width: 25px;
  height: 25px;
}

/* Image wrapper styles */
.image-wrapper {
  position: relative;
  margin: 0;
}

.main-img {
  height: 30vh;
  width: 100%;
  margin: 0 auto 0px;
}
.main-img.default-img {
  height: 35vh;
  width: 100px !important;
}

/* Information section styles */
.info {
  padding: 20px 20px 0px 20px;
}
.info .title {
  text-align: left;
  font-size: 25px;
  line-height: var(--modal-info-title-line-height);
  margin-bottom: 6px;
  padding-top: 10px;
  color: var(--ion-color-secondary);
  display: flex;
  align-items: center;
}
.info .desc {
  text-align: left;
  font-size: var(--modal-info-desc-font-size);
  font-family: AppFont, sans-serif;
  line-height: var(--modal-info-desc-line-height);
  padding-bottom: 10px;
  color: var(--ion-color-secondary);
}

/* Info button */
.bsg-info-button {
  background: transparent;
  border: none;
  padding: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  border-radius: 50%;
  margin-left: 5px;
  /* Focus styles */
  /* Key focus styles */
  /* Hover state */
}
.bsg-info-button:focus {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.bsg-info-button:focus-visible {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.bsg-info-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.bsg-info-button ion-icon {
  font-size: 17px;
}

/* Ingredients section */
.ingrediants-section {
  display: flex;
  justify-content: flex-end;
  padding: 10px 0px;
  align-items: center;
  width: 100%;
}
.ingrediants-section .bsg-remove-ingredients-button {
  cursor: pointer;
  text-align: left;
  font-size: 16px;
  font-family: AppFontBold, sans-serif;
  line-height: var(--modal-info-desc-line-height);
  padding: 8px;
  color: var(--ion-color-primary);
  text-decoration: underline;
  background: transparent;
  border: none;
  border-radius: 4px;
  /* Focus styles */
  /* Key focus styles */
  /* Hover state */
}
.ingrediants-section .bsg-remove-ingredients-button:focus {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.ingrediants-section .bsg-remove-ingredients-button:focus-visible {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.ingrediants-section .bsg-remove-ingredients-button:hover {
  color: #5a894c;
  text-decoration: underline;
}
@media (max-width: 992px) {
  .ingrediants-section .bsg-remove-ingredients-button {
    width: 50%;
    text-align: right;
  }
}

/* Option group styles */
.option-group-col {
  flex-grow: 1;
  overflow: auto;
  flex-shrink: 1;
  flex-basis: auto;
  padding: 15px 20px;
}

.option-group-description {
  line-height: 1.3;
  padding: 10px 25px 0px 20px;
  color: var(--ion-color-secondary);
  font-size: 16px;
  text-align: left;
  font-family: AppFontBold, sans-serif;
}

.show-option-groups {
  background: white;
  display: flex;
  align-items: center;
}

.last-item {
  height: 75px;
}

/* Notes input */
.input-notes {
  padding: 20px 20px 80px;
}
.input-notes ion-item {
  border: 1.5px solid var(--ion-color-primary);
  border-radius: 16px;
  margin-bottom: 10px;
  /* Focus styles */
}
.input-notes ion-item:focus-within {
  border-color: var(--ion-color-primary);
  box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);
}
.input-notes .container {
  position: relative;
}
.input-notes .container ion-label {
  position: absolute;
  left: 20px;
  background: white;
  top: -7px;
  z-index: 999;
  padding: 0px 10px;
  color: var(--ion-color-secondary);
}

/* Vegan indicators */
.vegan-block {
  display: flex;
  align-items: center;
}
.vegan-block ion-img {
  width: 35px;
  height: 24px;
}
.vegan-block p {
  text-transform: capitalize;
  margin-right: 5px;
  font-size: 12px;
  color: var(--ion-color-secondary);
}

/* Footer and button styles */
.button-footer-block {
  background: white;
  margin: 0px !important;
  padding: 15px;
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100%;
  z-index: 999;
  box-shadow: 0px -4px 50px 0px rgba(0, 0, 0, 0.1019607843);
  display: flex;
  flex-direction: column;
  font-size: 16px;
}
.button-footer-block ion-button {
  --padding-start: 24px;
  --padding-end: 7px;
  width: 100%;
  position: relative;
  /* Focus styles */
  /* Key focus styles */
}
.button-footer-block ion-button:focus {
  box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);
}
.button-footer-block ion-button:focus-visible {
  box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);
}
.button-footer-block ion-button .buuton-text {
  font-size: var(--modal-info-button-font-size);
  color: var(--modal-info-button-text-color);
  margin-right: 0;
}
.button-footer-block ion-button .buuton-text.one-button {
  margin-right: 35px;
}
.button-footer-block ion-button .button-icon {
  position: absolute;
  right: 5px;
  height: 34px;
  width: 34px;
}
.button-footer-block .footer-price-section {
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
}
.button-footer-block .footer-price-section .text-hint {
  font-family: AppFont, sans-serif;
  font-size: 14px;
  color: var(--ion-color-secondary);
}
.button-footer-block .footer-price-section .wrapper-with-quantity {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.button-footer-block .footer-price-section .wrapper-with-quantity .price-text {
  font-family: AppFontBold, sans-serif;
  font-size: 18px;
  color: var(--ion-color-secondary);
}

/* Quantity selector styles */
.quantity-selector {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.quantity-selector .quantity {
  color: var(--ion-color-secondary);
  font-size: 20px;
  font-family: AppFontBold;
  margin: 0 10px;
}
.quantity-selector .quantity-btn {
  background: transparent;
  border: none;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  /* Focus styles */
  /* Key focus styles */
  /* Hover state */
}
.quantity-selector .quantity-btn:focus {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.quantity-selector .quantity-btn:focus-visible {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.quantity-selector .quantity-btn:hover:not([disabled]) {
  background-color: rgba(0, 0, 0, 0.05);
}
.quantity-selector .quantity-btn.add-opacity {
  opacity: 0.5;
}
.quantity-selector .quantity-btn[disabled] {
  cursor: not-allowed;
}
.quantity-selector .quantity-btn ion-icon {
  width: 30px;
  height: 30px;
}

/* Container for scrollable content */
.style-block {
  height: 100%;
  overflow-y: auto;
  padding-bottom: 120px;
}

/* Focus trap marker elements for modal focus management */
.bsg-focus-trap-start,
.bsg-focus-trap-end {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

/* Keyboard focus indicators */
.bsg-keyboard-focus:focus-visible {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}

/* High contrast mode styles */
.bsg-high-contrast {
  /* Background and container styles */
  /* Header and navigation */
  /* Text and content */
  /* Interactive elements */
  /* Form elements */
  /* Footer elements */
  /* Vegan indicators in high contrast */
  /* Improve skip link visibility in high contrast */
  /* Enhance visibility of option groups */
  /* Add borders to sections for better visual separation */
  /* Announce screen reader content in high contrast mode */
}
.bsg-high-contrast swiper-container {
  background-color: white !important;
}
.bsg-high-contrast .slide-col {
  background: white !important;
}
.bsg-high-contrast .bsg-back-button:focus {
  outline: 3px solid #0078d7;
}
.bsg-high-contrast .bsg-back-button ion-icon {
  color: black;
}
.bsg-high-contrast .add_fav_btn {
  background: white;
  border: 2px solid black;
  box-shadow: none;
}
.bsg-high-contrast .add_fav_btn:focus {
  outline: 3px solid #0078d7;
}
.bsg-high-contrast .add_fav_btn ion-icon {
  color: black;
}
.bsg-high-contrast .title,
.bsg-high-contrast .desc,
.bsg-high-contrast .category-heading,
.bsg-high-contrast .option-group-description {
  color: black !important;
}
.bsg-high-contrast .info .desc {
  color: black !important;
}
.bsg-high-contrast .bsg-info-button:focus {
  outline: 3px solid #0078d7;
}
.bsg-high-contrast .bsg-info-button ion-icon {
  color: black;
}
.bsg-high-contrast .bsg-remove-ingredients-button {
  color: #0078d7 !important;
  text-decoration: underline;
}
.bsg-high-contrast .bsg-remove-ingredients-button:focus {
  outline: 3px solid #0078d7;
}
.bsg-high-contrast .input-notes ion-item {
  border-color: black;
}
.bsg-high-contrast .input-notes ion-item:focus-within {
  border-color: #0078d7;
  box-shadow: 0 0 0 3px rgba(0, 120, 215, 0.25);
}
.bsg-high-contrast ion-label {
  background: white !important;
  color: black !important;
}
.bsg-high-contrast .button-footer-block {
  background: white;
  border-top: 2px solid black;
}
.bsg-high-contrast .button-footer-block .text-hint,
.bsg-high-contrast .button-footer-block .price-text,
.bsg-high-contrast .button-footer-block .quantity {
  color: black !important;
}
.bsg-high-contrast .button-footer-block ion-button {
  /* Add higher contrast to button text and icons */
  /* Disabled button styles for high contrast */
}
.bsg-high-contrast .button-footer-block ion-button:focus {
  box-shadow: 0 0 0 3px #0078d7;
}
.bsg-high-contrast .button-footer-block ion-button .buuton-text {
  color: white !important;
  font-weight: bold;
}
.bsg-high-contrast .button-footer-block ion-button .button-icon {
  color: white !important;
}
.bsg-high-contrast .button-footer-block ion-button[disabled] {
  opacity: 0.6;
  border: 1px dashed black;
}
.bsg-high-contrast .button-footer-block ion-button[disabled] .buuton-text {
  color: #666666 !important;
}
.bsg-high-contrast .quantity-btn {
  /* Disabled button style */
}
.bsg-high-contrast .quantity-btn:focus {
  outline: 3px solid #0078d7;
}
.bsg-high-contrast .quantity-btn ion-icon {
  color: black;
}
.bsg-high-contrast .quantity-btn[disabled], .bsg-high-contrast .quantity-btn.add-opacity {
  opacity: 0.5;
  border: 1px dashed black;
}
.bsg-high-contrast .vegan-block ion-img {
  border: 1px solid black;
}
.bsg-high-contrast .bsg-skip-link:focus {
  outline: 3px solid #0078d7;
  color: black;
  background: white;
  border: 2px solid black;
  z-index: 10001;
}
.bsg-high-contrast .show-option-groups {
  border-bottom: 1px solid black;
}
.bsg-high-contrast .style-block > div {
  border-bottom: 1px solid #cccccc;
}
.bsg-high-contrast .visually-hidden {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/components/modal-info/modal-info.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAAA,6CAAA;AAGA,qCAAA;AACA;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;AADD;;AAIA,iCAAA;AACA;EACC,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,iCAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;EACA,0CAAA;EACA,qBAAA;AADD;AAGC;EACC,SAAA;EACA,UAAA;AADF;;AAKA,qBAAA;AACA;EACC,kBAAA;EACA,YAAA;AAFD;;AAKA;EACC,aAAA;EACA,kBAAA;AAFD;;AAKA;EACC,sBAAA;EACA,uBAAA;EACA,yCAAA;AAFD;;AAKA;EACC,sBAAA;AAFD;;AAKA;EACC,uBAAA;AAFD;;AAKA,wBAAA;AACA;EACC,MAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,cAAA;AAFD;AAIC;EACC,sBAAA;AAFF;;AAMA,0BAAA;AACA;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;AAHD;;AAMA,qBAAA;AACA;EACC,SAAA;EACA,eAAA;EACA,iCAAA;AAHD;;AAMA,gBAAA;AACA;EACC,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EAEA,iBAAA;EAMA,gBAAA;EAKA,qBAAA;AAbD;AAGC;EACC,2CAAA;EACA,mBAAA;AADF;AAKC;EACC,qCAAA;AAHF;AAOC;EACC,2CAAA;EACA,mBAAA;AALF;AAQC;EACC,WAAA;EACA,YAAA;AANF;;AAUA,oBAAA;AACA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,4DAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAMA,iBAAA;EAMA,qBAAA;EAMA,gBAAA;AAtBD;AAMC;EACC,gBAAA;AAJF;AAQC;EACC,2CAAA;EACA,mBAAA;AANF;AAUC;EACC,2CAAA;EACA,mBAAA;AARF;AAYC;EACC,qCAAA;AAVF;AAaC;EACC,WAAA;EACA,YAAA;AAXF;;AAeA,yBAAA;AACA;EACC,kBAAA;EACA,SAAA;AAZD;;AAeA;EACC,YAAA;EACA,WAAA;EACA,kBAAA;AAZD;AAcC;EACC,YAAA;EACA,uBAAA;AAZF;;AAgBA,+BAAA;AACA;EACC,2BAAA;AAbD;AAeC;EACC,gBAAA;EACA,eAAA;EACA,gDAAA;EACA,kBAAA;EACA,iBAAA;EACA,iCAAA;EACA,aAAA;EACA,mBAAA;AAbF;AAgBC;EACC,gBAAA;EACA,2CAAA;EACA,gCAAA;EACA,+CAAA;EACA,oBAAA;EACA,iCAAA;AAdF;;AAkBA,gBAAA;AACA;EACC,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,iBAAA;EAMA,qBAAA;EAMA,gBAAA;AA1BD;AAeC;EACC,2CAAA;EACA,mBAAA;AAbF;AAiBC;EACC,2CAAA;EACA,mBAAA;AAfF;AAmBC;EACC,qCAAA;AAjBF;AAoBC;EACC,eAAA;AAlBF;;AAsBA,wBAAA;AACA;EACC,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;AAnBD;AAqBC;EACC,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oCAAA;EACA,+CAAA;EACA,YAAA;EACA,+BAAA;EACA,0BAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EAEA,iBAAA;EAMA,qBAAA;EAMA,gBAAA;AA9BF;AAmBE;EACC,2CAAA;EACA,mBAAA;AAjBH;AAqBE;EACC,2CAAA;EACA,mBAAA;AAnBH;AAuBE;EACC,cAAA;EACA,0BAAA;AArBH;ACrPE;ED8OD;IAgCE,UAAA;IACA,iBAAA;EArBD;AACF;;AAyBA,wBAAA;AACA;EACC,YAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAtBD;;AAyBA;EACC,gBAAA;EACA,2BAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;AAtBD;;AAyBA;EACC,iBAAA;EACA,aAAA;EACA,mBAAA;AAtBD;;AAyBA;EACC,YAAA;AAtBD;;AAyBA,gBAAA;AACA;EACC,uBAAA;AAtBD;AAwBC;EACC,4CAAA;EACA,mBAAA;EACA,mBAAA;EAEA,iBAAA;AAvBF;AAwBE;EACC,sCAAA;EACA,8CAAA;AAtBH;AA0BC;EACC,kBAAA;AAxBF;AA0BE;EACC,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,iCAAA;AAxBH;;AA6BA,qBAAA;AACA;EACC,aAAA;EACA,mBAAA;AA1BD;AA4BC;EACC,WAAA;EACA,YAAA;AA1BF;AA6BC;EACC,0BAAA;EACA,iBAAA;EACA,eAAA;EACA,iCAAA;AA3BF;;AA+BA,6BAAA;AACA;EACC,iBAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;AA5BD;AA8BC;EACC,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EAEA,iBAAA;EAKA,qBAAA;AAjCF;AA6BE;EACC,8CAAA;AA3BH;AA+BE;EACC,8CAAA;AA7BH;AAgCE;EACC,6CAAA;EACA,0CAAA;EACA,eAAA;AA9BH;AAgCG;EACC,kBAAA;AA9BJ;AAkCE;EACC,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AAhCH;AAoCC;EACC,aAAA;EACA,sBAAA;EACA,oBAAA;AAlCF;AAoCE;EACC,gCAAA;EACA,eAAA;EACA,iCAAA;AAlCH;AAqCE;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAnCH;AAqCG;EACC,oCAAA;EACA,eAAA;EACA,iCAAA;AAnCJ;;AAyCA,6BAAA;AACA;EACC,aAAA;EACA,yBAAA;EACA,mBAAA;AAtCD;AAwCC;EACC,iCAAA;EACA,eAAA;EACA,wBAAA;EACA,cAAA;AAtCF;AAyCC;EACC,uBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EAEA,iBAAA;EAMA,qBAAA;EAMA,gBAAA;AAlDF;AAuCE;EACC,2CAAA;EACA,mBAAA;AArCH;AAyCE;EACC,2CAAA;EACA,mBAAA;AAvCH;AA2CE;EACC,qCAAA;AAzCH;AA4CE;EACC,YAAA;AA1CH;AA6CE;EACC,mBAAA;AA3CH;AA8CE;EACC,WAAA;EACA,YAAA;AA5CH;;AAiDA,qCAAA;AACA;EACC,YAAA;EACA,gBAAA;EACA,qBAAA;AA9CD;;AAiDA,0DAAA;AACA;;EAEC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;AA9CD;;AAiDA,8BAAA;AAEC;EACC,2CAAA;EACA,mBAAA;AA/CF;;AAmDA,8BAAA;AACA;EACC,oCAAA;EASA,0BAAA;EAyBA,qBAAA;EAYA,yBAAA;EAoBA,kBAAA;EAeA,oBAAA;EAuDA,sCAAA;EAOA,kDAAA;EASA,wCAAA;EAKA,yDAAA;EAKA,yDAAA;AAxMD;AAuCC;EACC,kCAAA;AArCF;AAwCC;EACC,4BAAA;AAtCF;AA2CE;EACC,0BAAA;AAzCH;AA4CE;EACC,YAAA;AA1CH;AA8CC;EACC,iBAAA;EACA,uBAAA;EACA,gBAAA;AA5CF;AA8CE;EACC,0BAAA;AA5CH;AA+CE;EACC,YAAA;AA7CH;AAkDC;;;;EAIC,uBAAA;AAhDF;AAmDC;EACC,uBAAA;AAjDF;AAsDE;EACC,0BAAA;AApDH;AAuDE;EACC,YAAA;AArDH;AAyDC;EACC,yBAAA;EACA,0BAAA;AAvDF;AAyDE;EACC,0BAAA;AAvDH;AA4DC;EACC,mBAAA;AA1DF;AA4DE;EACC,qBAAA;EACA,6CAAA;AA1DH;AA8DC;EACC,4BAAA;EACA,uBAAA;AA5DF;AAgEC;EACC,iBAAA;EACA,2BAAA;AA9DF;AAgEE;;;EAGC,uBAAA;AA9DH;AAiEE;EAKC,iDAAA;EAUA,6CAAA;AA5EH;AA8DG;EACC,6BAAA;AA5DJ;AAgEG;EACC,uBAAA;EACA,iBAAA;AA9DJ;AAiEG;EACC,uBAAA;AA/DJ;AAmEG;EACC,YAAA;EACA,wBAAA;AAjEJ;AAmEI;EACC,yBAAA;AAjEL;AAuEC;EASC,0BAAA;AA7EF;AAqEE;EACC,0BAAA;AAnEH;AAsEE;EACC,YAAA;AApEH;AAwEE;EAEC,YAAA;EACA,wBAAA;AAvEH;AA6EE;EACC,uBAAA;AA3EH;AAgFC;EACC,0BAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;AA9EF;AAkFC;EACC,8BAAA;AAhFF;AAoFC;EACC,gCAAA;AAlFF;AAsFC;EACC,aAAA;AApFF","sourcesContent":["/* BSG-compliant styles for food item modal */\n@import '../../../theme/mixins';\n\n/* Utility class for screen readers */\n.visually-hidden {\n\tposition: absolute;\n\twidth: 1px;\n\theight: 1px;\n\tmargin: -1px;\n\tpadding: 0;\n\toverflow: hidden;\n\tclip: rect(0, 0, 0, 0);\n\tborder: 0;\n}\n\n/* Skip link for keyboard users */\n.bsg-skip-link {\n\tposition: absolute;\n\ttop: -9999px;\n\tleft: -9999px;\n\tbackground: white;\n\tcolor: var(--ion-color-secondary);\n\tpadding: 15px;\n\tz-index: 10000;\n\tfont-weight: bold;\n\tborder: 2px solid var(--ion-color-primary);\n\ttext-decoration: none;\n\n\t&:focus {\n\t\ttop: 10px;\n\t\tleft: 10px;\n\t}\n}\n\n/* Container styles */\n.bsg-modal-container {\n\tposition: relative;\n\theight: 100%;\n}\n\napp-modal-info {\n\theight: 100vh;\n\tposition: relative;\n}\n\nswiper-container {\n\twidth: 100% !important;\n\theight: 100% !important;\n\tbackground-color: var(--background-color);\n}\n\nswiper-slide {\n\twidth: 100% !important;\n}\n\nion-page {\n\tbackground: transparent;\n}\n\n/* Slide column styles */\n.slide-col {\n\ttop: 0;\n\tbottom: 0;\n\tposition: absolute;\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground-size: 100% 30vh !important;\n\toverflow: auto;\n\n\t&.add-background {\n\t\tbackground-size: cover;\n\t}\n}\n\n/* Header wrapper styles */\n.header-wrapper {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tpadding: 20px;\n\talign-items: center;\n}\n\n/* Category heading */\n.category-heading {\n\tmargin: 0;\n\tfont-size: 18px;\n\tcolor: var(--ion-color-secondary);\n}\n\n/* Back button */\n.bsg-back-button {\n\tbackground: transparent;\n\tborder: none;\n\tpadding: 8px;\n\tcursor: pointer;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 50%;\n\n\t/* Focus styles */\n\t&:focus {\n\t\toutline: 3px solid var(--ion-color-primary);\n\t\toutline-offset: 2px;\n\t}\n\n\t/* Hover state */\n\t&:hover {\n\t\tbackground-color: rgba(0, 0, 0, 0.05);\n\t}\n\n\t/* Key focus styles */\n\t&:focus-visible {\n\t\toutline: 3px solid var(--ion-color-primary);\n\t\toutline-offset: 2px;\n\t}\n\n\tion-icon {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t}\n}\n\n/* Favorite button */\n.add_fav_btn {\n\twidth: 40px;\n\theight: 40px;\n\tbackground: white;\n\tborder-radius: 50%;\n\tbox-shadow: 0px 0px 20px 0px #0d47a126;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\t&.no-shadow {\n\t\tbox-shadow: none;\n\t}\n\n\t/* Focus styles */\n\t&:focus {\n\t\toutline: 3px solid var(--ion-color-primary);\n\t\toutline-offset: 2px;\n\t}\n\n\t/* Key focus styles */\n\t&:focus-visible {\n\t\toutline: 3px solid var(--ion-color-primary);\n\t\toutline-offset: 2px;\n\t}\n\n\t/* Hover state */\n\t&:hover {\n\t\tbackground-color: rgba(0, 0, 0, 0.02);\n\t}\n\n\tion-icon {\n\t\twidth: 25px;\n\t\theight: 25px;\n\t}\n}\n\n/* Image wrapper styles */\n.image-wrapper {\n\tposition: relative;\n\tmargin: 0;\n}\n\n.main-img {\n\theight: 30vh;\n\twidth: 100%;\n\tmargin: 0 auto 0px;\n\n\t&.default-img {\n\t\theight: 35vh;\n\t\twidth: 100px !important;\n\t}\n}\n\n/* Information section styles */\n.info {\n\tpadding: 20px 20px 0px 20px;\n\n\t.title {\n\t\ttext-align: left;\n\t\tfont-size: 25px;\n\t\tline-height: var(--modal-info-title-line-height);\n\t\tmargin-bottom: 6px;\n\t\tpadding-top: 10px;\n\t\tcolor: var(--ion-color-secondary);\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t}\n\n\t.desc {\n\t\ttext-align: left;\n\t\tfont-size: var(--modal-info-desc-font-size);\n\t\tfont-family: AppFont, sans-serif;\n\t\tline-height: var(--modal-info-desc-line-height);\n\t\tpadding-bottom: 10px;\n\t\tcolor: var(--ion-color-secondary);\n\t}\n}\n\n/* Info button */\n.bsg-info-button {\n\tbackground: transparent;\n\tborder: none;\n\tpadding: 8px;\n\tcursor: pointer;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tborder-radius: 50%;\n\tmargin-left: 5px;\n\n\t/* Focus styles */\n\t&:focus {\n\t\toutline: 3px solid var(--ion-color-primary);\n\t\toutline-offset: 2px;\n\t}\n\n\t/* Key focus styles */\n\t&:focus-visible {\n\t\toutline: 3px solid var(--ion-color-primary);\n\t\toutline-offset: 2px;\n\t}\n\n\t/* Hover state */\n\t&:hover {\n\t\tbackground-color: rgba(0, 0, 0, 0.05);\n\t}\n\n\tion-icon {\n\t\tfont-size: 17px;\n\t}\n}\n\n/* Ingredients section */\n.ingrediants-section {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tpadding: 10px 0px;\n\talign-items: center;\n\twidth: 100%;\n\n\t.bsg-remove-ingredients-button {\n\t\tcursor: pointer;\n\t\ttext-align: left;\n\t\tfont-size: 16px;\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tline-height: var(--modal-info-desc-line-height);\n\t\tpadding: 8px;\n\t\tcolor: var(--ion-color-primary);\n\t\ttext-decoration: underline;\n\t\tbackground: transparent;\n\t\tborder: none;\n\t\tborder-radius: 4px;\n\n\t\t/* Focus styles */\n\t\t&:focus {\n\t\t\toutline: 3px solid var(--ion-color-primary);\n\t\t\toutline-offset: 2px;\n\t\t}\n\n\t\t/* Key focus styles */\n\t\t&:focus-visible {\n\t\t\toutline: 3px solid var(--ion-color-primary);\n\t\t\toutline-offset: 2px;\n\t\t}\n\n\t\t/* Hover state */\n\t\t&:hover {\n\t\t\tcolor: darken(#71a761, 10%);\n\t\t\ttext-decoration: underline;\n\t\t}\n\n\t\t@include mobile {\n\t\t\twidth: 50%;\n\t\t\ttext-align: right;\n\t\t}\n\t}\n}\n\n/* Option group styles */\n.option-group-col {\n\tflex-grow: 1;\n\toverflow: auto;\n\tflex-shrink: 1;\n\tflex-basis: auto;\n\tpadding: 15px 20px;\n}\n\n.option-group-description {\n\tline-height: 1.3;\n\tpadding: 10px 25px 0px 20px;\n\tcolor: var(--ion-color-secondary);\n\tfont-size: 16px;\n\ttext-align: left;\n\tfont-family: AppFontBold, sans-serif;\n}\n\n.show-option-groups {\n\tbackground: white;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.last-item {\n\theight: 75px;\n}\n\n/* Notes input */\n.input-notes {\n\tpadding: 20px 20px 80px;\n\n\tion-item {\n\t\tborder: 1.5px solid var(--ion-color-primary);\n\t\tborder-radius: 16px;\n\t\tmargin-bottom: 10px;\n\n\t\t/* Focus styles */\n\t\t&:focus-within {\n\t\t\tborder-color: var(--ion-color-primary);\n\t\t\tbox-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);\n\t\t}\n\t}\n\n\t.container {\n\t\tposition: relative;\n\n\t\tion-label {\n\t\t\tposition: absolute;\n\t\t\tleft: 20px;\n\t\t\tbackground: white;\n\t\t\ttop: -7px;\n\t\t\tz-index: 999;\n\t\t\tpadding: 0px 10px;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t}\n\t}\n}\n\n/* Vegan indicators */\n.vegan-block {\n\tdisplay: flex;\n\talign-items: center;\n\n\tion-img {\n\t\twidth: 35px;\n\t\theight: 24px;\n\t}\n\n\tp {\n\t\ttext-transform: capitalize;\n\t\tmargin-right: 5px;\n\t\tfont-size: 12px;\n\t\tcolor: var(--ion-color-secondary);\n\t}\n}\n\n/* Footer and button styles */\n.button-footer-block {\n\tbackground: white;\n\tmargin: 0px !important;\n\tpadding: 15px;\n\tposition: fixed;\n\tbottom: 0px;\n\tleft: 0px;\n\twidth: 100%;\n\tz-index: 999;\n\tbox-shadow: 0px -4px 50px 0px #0000001a;\n\tdisplay: flex;\n\tflex-direction: column;\n\tfont-size: 16px;\n\n\tion-button {\n\t\t--padding-start: 24px;\n\t\t--padding-end: 7px;\n\t\twidth: 100%;\n\t\tposition: relative;\n\n\t\t/* Focus styles */\n\t\t&:focus {\n\t\t\tbox-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);\n\t\t}\n\n\t\t/* Key focus styles */\n\t\t&:focus-visible {\n\t\t\tbox-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);\n\t\t}\n\n\t\t.buuton-text {\n\t\t\tfont-size: var(--modal-info-button-font-size);\n\t\t\tcolor: var(--modal-info-button-text-color);\n\t\t\tmargin-right: 0;\n\n\t\t\t&.one-button {\n\t\t\t\tmargin-right: 35px;\n\t\t\t}\n\t\t}\n\n\t\t.button-icon {\n\t\t\tposition: absolute;\n\t\t\tright: 5px;\n\t\t\theight: 34px;\n\t\t\twidth: 34px;\n\t\t}\n\t}\n\n\t.footer-price-section {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tpadding-bottom: 10px;\n\n\t\t.text-hint {\n\t\t\tfont-family: AppFont, sans-serif;\n\t\t\tfont-size: 14px;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t}\n\n\t\t.wrapper-with-quantity {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: center;\n\n\t\t\t.price-text {\n\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\tfont-size: 18px;\n\t\t\t\tcolor: var(--ion-color-secondary);\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* Quantity selector styles */\n.quantity-selector {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\talign-items: center;\n\n\t.quantity {\n\t\tcolor: var(--ion-color-secondary);\n\t\tfont-size: 20px;\n\t\tfont-family: AppFontBold;\n\t\tmargin: 0 10px;\n\t}\n\n\t.quantity-btn {\n\t\tbackground: transparent;\n\t\tborder: none;\n\t\tpadding: 8px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tcursor: pointer;\n\t\tborder-radius: 50%;\n\n\t\t/* Focus styles */\n\t\t&:focus {\n\t\t\toutline: 3px solid var(--ion-color-primary);\n\t\t\toutline-offset: 2px;\n\t\t}\n\n\t\t/* Key focus styles */\n\t\t&:focus-visible {\n\t\t\toutline: 3px solid var(--ion-color-primary);\n\t\t\toutline-offset: 2px;\n\t\t}\n\n\t\t/* Hover state */\n\t\t&:hover:not([disabled]) {\n\t\t\tbackground-color: rgba(0, 0, 0, 0.05);\n\t\t}\n\n\t\t&.add-opacity {\n\t\t\topacity: 0.5;\n\t\t}\n\n\t\t&[disabled] {\n\t\t\tcursor: not-allowed;\n\t\t}\n\n\t\tion-icon {\n\t\t\twidth: 30px;\n\t\t\theight: 30px;\n\t\t}\n\t}\n}\n\n/* Container for scrollable content */\n.style-block {\n\theight: 100%;\n\toverflow-y: auto;\n\tpadding-bottom: 120px;\n}\n\n/* Focus trap marker elements for modal focus management */\n.bsg-focus-trap-start,\n.bsg-focus-trap-end {\n\tposition: absolute;\n\twidth: 1px;\n\theight: 1px;\n\tpadding: 0;\n\tmargin: -1px;\n\toverflow: hidden;\n\tclip: rect(0, 0, 0, 0);\n\tborder: 0;\n}\n\n/* Keyboard focus indicators */\n.bsg-keyboard-focus {\n\t&:focus-visible {\n\t\toutline: 3px solid var(--ion-color-primary);\n\t\toutline-offset: 2px;\n\t}\n}\n\n/* High contrast mode styles */\n.bsg-high-contrast {\n\t/* Background and container styles */\n\tswiper-container {\n\t\tbackground-color: white !important;\n\t}\n\n\t.slide-col {\n\t\tbackground: white !important;\n\t}\n\n\t/* Header and navigation */\n\t.bsg-back-button {\n\t\t&:focus {\n\t\t\toutline: 3px solid #0078d7;\n\t\t}\n\n\t\tion-icon {\n\t\t\tcolor: black;\n\t\t}\n\t}\n\n\t.add_fav_btn {\n\t\tbackground: white;\n\t\tborder: 2px solid black;\n\t\tbox-shadow: none;\n\n\t\t&:focus {\n\t\t\toutline: 3px solid #0078d7;\n\t\t}\n\n\t\tion-icon {\n\t\t\tcolor: black;\n\t\t}\n\t}\n\n\t/* Text and content */\n\t.title,\n\t.desc,\n\t.category-heading,\n\t.option-group-description {\n\t\tcolor: black !important;\n\t}\n\n\t.info .desc {\n\t\tcolor: black !important;\n\t}\n\n\t/* Interactive elements */\n\t.bsg-info-button {\n\t\t&:focus {\n\t\t\toutline: 3px solid #0078d7;\n\t\t}\n\n\t\tion-icon {\n\t\t\tcolor: black;\n\t\t}\n\t}\n\n\t.bsg-remove-ingredients-button {\n\t\tcolor: #0078d7 !important;\n\t\ttext-decoration: underline;\n\n\t\t&:focus {\n\t\t\toutline: 3px solid #0078d7;\n\t\t}\n\t}\n\n\t/* Form elements */\n\t.input-notes ion-item {\n\t\tborder-color: black;\n\n\t\t&:focus-within {\n\t\t\tborder-color: #0078d7;\n\t\t\tbox-shadow: 0 0 0 3px rgba(0, 120, 215, 0.25);\n\t\t}\n\t}\n\n\tion-label {\n\t\tbackground: white !important;\n\t\tcolor: black !important;\n\t}\n\n\t/* Footer elements */\n\t.button-footer-block {\n\t\tbackground: white;\n\t\tborder-top: 2px solid black;\n\n\t\t.text-hint,\n\t\t.price-text,\n\t\t.quantity {\n\t\t\tcolor: black !important;\n\t\t}\n\n\t\tion-button {\n\t\t\t&:focus {\n\t\t\t\tbox-shadow: 0 0 0 3px #0078d7;\n\t\t\t}\n\n\t\t\t/* Add higher contrast to button text and icons */\n\t\t\t.buuton-text {\n\t\t\t\tcolor: white !important;\n\t\t\t\tfont-weight: bold;\n\t\t\t}\n\n\t\t\t.button-icon {\n\t\t\t\tcolor: white !important;\n\t\t\t}\n\n\t\t\t/* Disabled button styles for high contrast */\n\t\t\t&[disabled] {\n\t\t\t\topacity: 0.6;\n\t\t\t\tborder: 1px dashed black;\n\n\t\t\t\t.buuton-text {\n\t\t\t\t\tcolor: #666666 !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.quantity-btn {\n\t\t&:focus {\n\t\t\toutline: 3px solid #0078d7;\n\t\t}\n\n\t\tion-icon {\n\t\t\tcolor: black;\n\t\t}\n\n\t\t/* Disabled button style */\n\t\t&[disabled],\n\t\t&.add-opacity {\n\t\t\topacity: 0.5;\n\t\t\tborder: 1px dashed black;\n\t\t}\n\t}\n\n\t/* Vegan indicators in high contrast */\n\t.vegan-block {\n\t\tion-img {\n\t\t\tborder: 1px solid black;\n\t\t}\n\t}\n\n\t/* Improve skip link visibility in high contrast */\n\t.bsg-skip-link:focus {\n\t\toutline: 3px solid #0078d7;\n\t\tcolor: black;\n\t\tbackground: white;\n\t\tborder: 2px solid black;\n\t\tz-index: 10001;\n\t}\n\n\t/* Enhance visibility of option groups */\n\t.show-option-groups {\n\t\tborder-bottom: 1px solid black;\n\t}\n\n\t/* Add borders to sections for better visual separation */\n\t.style-block > div {\n\t\tborder-bottom: 1px solid #cccccc;\n\t}\n\n\t/* Announce screen reader content in high contrast mode */\n\t.visually-hidden {\n\t\tdisplay: none;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
